import { useSortable } from "@dnd-kit/sortable";
import { Box, ListItem, ListItemText, Stack } from "@mui/material";
import { CSS } from '@dnd-kit/utilities';
import ListDragHandle from "../../../components/list-drag-handle/ListDragHandle";
import FormInput from "../../../components/forms/form-input/FormInput";
import { useTranslation } from "react-i18next";
import ActionMenu from "../../../components/action-menu/ActionMenu";
import { AttributeSchemaFormType } from "../AttributeSchemaEditorUtils";
import { useFormContext } from "react-hook-form";

export type AttributeValueOptionProps = {
    id: number;
    name: string;
    readOnly?: boolean;
    onDelete?: (id: number) => void
};

export function AttributeValueOption({
    id,
    name,
    readOnly,
    onDelete
}: AttributeValueOptionProps) {

    const { t } = useTranslation();

    const {
        attributes,
        listeners,
        transform,
        transition,
        isDragging,
        setNodeRef,
        setActivatorNodeRef
    } = useSortable({ id: id.toString() ?? '' });



    const {
        getValues,
        //watch,
        //trigger,
        //control,
        //reset,
        //setValue,
        //resetField
    } = useFormContext<AttributeSchemaFormType>();    

    const _validateValue = (value: string): boolean => {
        return value.toString().trim().length <= 128;
    }

    const _validateUnique = (value: string): boolean => {

        const valueOptions = getValues('valueOptions');

        return valueOptions.find(o => o.id !== id && o.value.toLocaleLowerCase() === value.trim().toLocaleLowerCase()) === undefined;
    }

    const isReadOnly = readOnly && id > 0;
    
    return (
        <ListItem
            ref={setNodeRef}
            dense
            sx={{
                margin: 0,
                paddingLeft: 0,
                transform: CSS.Transform.toString(transform),
                transition,
                opacity: isDragging ? theme => theme.palette.action.disabledOpacity : 1,
                position: 'relative'
            }}
        >
            <ListItemText 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: 0
                }}
                primary={
                    <>
                        <Stack>
                            <ListDragHandle
                                ref={setActivatorNodeRef}
                                {...listeners}
                                {...attributes}
                                sx={{
                                    display: 'flex',
                                    //visibility: isReadOnly ? 'hidden' : undefined
                                }}
                            />

                        </Stack>

                        <FormInput
                            name={name}
                            rules={!isReadOnly ? { 
                                required: {
                                    value: true,
                                    message: t('attributeSchema.valueRequired')
                                },
                                validate: (value: string) => !_validateValue(value) ?
                                t('properties.maxAttributeLength') : 
                                !_validateUnique(value) ? 
                                t('attributeSchema.valueUnique') : 
                                true
                            } : undefined}
                            readOnly={readOnly && id > 0}
                            sx={{ 
                                width: "100%",
                                marginRight: 1
                            }}
                        />

                        <Box
                            sx={{
                                display: 'flex',
                                visibility: isReadOnly ? 'hidden' : undefined
                            }}>
                            <ActionMenu
                                actionItems={[{
                                    label: t('actions.delete'),
                                    onClick: () => {onDelete && onDelete(id)}
                                    
                                }]}
                            />
                        </Box>

                    </>
                } 
            
                slotProps={{
                    primary: {
                        component: 'div',
                        sx: {
                            display: 'flex',
                        }
                    }
                }} 
            />
        </ListItem>
    );
}

